/* Manage password visibility toggle buttons */

document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll<HTMLButtonElement>('button[data-show-password]');

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      // Retrieve options from data-show-password attribute as JSON 
      const attr = button.getAttribute('data-show-password');
      let options: { target?: string } = {};
      if (attr) {
        try {
          options = JSON.parse(attr);
        } catch (e) {
          // If parsing fails, fallback to empty object
          options = {};
        }
      }

      // Locating the associated input element
      let input: HTMLInputElement | null = null;
      if (options.target) {
        input = document.querySelector<HTMLInputElement>(options.target);
      } else {
        // Fallback 1: search for input inside the button's parent element
        input = button.parentElement?.querySelector<HTMLInputElement>('input[type="password"], input[type="text"]') || null;
        // Fallback 2: if not found, search for closest input in the form
        if (!input) {
          input = button.closest('form')?.querySelector<HTMLInputElement>('input[type="password"], input[type="text"]') || null;
        }
      }

      // Toggle the input type between password and text
      if (input) {
        input.type = input.type === 'password' ? 'text' : 'password';
      }
    });
  });
});
